module.exports = __webpack_public_path__ + "static/media/46.b94eb112.jpg";